import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FetchAttributeDataSubject {
  constructor() {}
  fetchAttributeData: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private fetchTimeout: any;

  // handleFetchData(val: boolean) {
  //   this.fetchAttributeData.subscribe((currentValue) => {
  //     if (!!val && !currentValue) {
  //       this.fetchAttributeData.next(true);
  //       setTimeout(() => {
  //         this.fetchAttributeData.next(false);
  //       }, 2000);
  //     } else if (!val) {
  //       this.fetchAttributeData.next(false);
  //     }
  //   });
  // }

  handleFetchData(val: boolean) {
    if (val) {
      this.fetchAttributeData.pipe(take(1)).subscribe((currentValue) => {
        if (!currentValue) {
          this.fetchAttributeData.next(true);
          this.clearFetchTimeout();
          this.fetchTimeout = setTimeout(() => {
            this.fetchAttributeData.next(false);
          }, 2000);
        }
      });
    } else {
      this.fetchAttributeData.next(false);
      this.clearFetchTimeout();
    }
  }

  private clearFetchTimeout() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
      this.fetchTimeout = null;
    }
  }
}
